import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';

import { getMailtoLink } from 'utils';
import { useDeleteLinkedMemberMutation } from 'store/api/version-api.slice';
import { LoaderButton } from 'components/ProgressButton';

const DeleteLinkedMemberDialog = ({ isOpen, onClose, data = {} }) => {
	const { primary_member } = useParams();

	const [deleteMember, { isLoading }] = useDeleteLinkedMemberMutation();

	const handleProceed = async () => {
		const response = await deleteMember({ primary_member, old_secondary_member: data.id });

		if (response.data) {
			toast(response.data.msg, { type: 'info' });
			onClose();
		}
	};

	return (
		<Dialog open={isOpen} onClose={onClose} maxWidth={'sm'} fullWidth={true}>
			<DialogTitle>
				<Typography variant="h6" color="error" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
					<PersonRemoveIcon sx={{ mr: 1 }} /> Remove linked member
				</Typography>
			</DialogTitle>
			<DialogContent>
				<IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={onClose}>
					<CloseIcon />
				</IconButton>
				<Stack spacing={3} sx={{ pt: 1 }}>
					<Typography>
						Are you sure you want to remove {data.fullname} (
						<Link component="a" rel="noopener noreferrer" href={getMailtoLink(data.email)}>
							{data.email}
						</Link>
						) from Linked Members?
					</Typography>
					<Stack direction="row" sx={{ justifyContent: 'flex-end', alignItems: 'center' }} spacing={2}>
						<Button
							onClick={onClose}
							variant="text"
							sx={{ maxWidth: 100, width: '100%', alignSelf: 'flex-end' }}
							color="secondary"
							disabled={isLoading}
						>
							Cancel
						</Button>
						<LoaderButton
							onClick={handleProceed}
							variant="outlined"
							color="error"
							circleColor="error"
							loading={isLoading}
							circleSize={16}
							sx={{ alignSelf: 'flex-end' }}
						>
							Proceed
						</LoaderButton>
					</Stack>
				</Stack>
			</DialogContent>
		</Dialog>
	);
};

export default DeleteLinkedMemberDialog;
